import { breakpoints } from '../constants/screen';

export const sortedBreakpoints = Object
  .values(breakpoints)
  .sort((bpA, brB) => brB.minWidth - bpA.minWidth);

const isBreakpointUp = (width, breakpoint) => (width >= breakpoint.minWidth);
const getWidth = () => Math.max(
  document.documentElement.clientWidth,
  window.innerWidth || 0,
);

export const isMobileLargeUp = () => isBreakpointUp(getWidth(), breakpoints.mobileL);
export const isTabletUp = () => isBreakpointUp(getWidth(), breakpoints.tablet);
export const isDesktopUp = () => isBreakpointUp(getWidth(), breakpoints.desktop);
export const getBreakpoint = () => {
  const width = getWidth();
  return sortedBreakpoints.find((breakpoint) => isBreakpointUp(width, breakpoint));
};

/**
 * Checks if the user agent has the preference
 * for reduced motion enabled.
 */
export const prefersReducedMotion = () => {
  const match = typeof window.matchMedia !== 'function' ? true :
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  return match;
};

export const NO_SCROLL = 'no-scroll';
export const DESKTOP_DOWN = '--desktop-down';

/**
 * Disabled scrolling of the document for modals and other fullscreen components.
 *
 * @param {Boolean} lock whether to lock scroll
 * @param {Boolean} desktopDownOnly whether to apply the --desktop-down class
 */
export const toggleScrollLock = (lock, classSuffix = '') => {
  document.body.classList.toggle(`${NO_SCROLL}${classSuffix}`, lock);
};

export const addScrollLock = (className = '') => {
  document.body.classList.add(className);
};

export const removeScrollLock = (className = '') => {
  document.body.classList.remove(className);
};
